import { Grid } from "@mui/material";
import DeviceStats from "components/Charts/DeviceStats";
import PropTypes from "prop-types";

function StatisticsTab({ uuid, deviceLayout }) {
    return <DeviceStats title="Stats Chart" height={deviceLayout == 'mobile' ? "300px" : "calc((100svh - 23.5rem - 16px)/2)"} uuid={uuid} />;
}

StatisticsTab.propTypes = {
    uuid: PropTypes.string,
    deviceLayout: PropTypes.string
}

export default StatisticsTab;